<mat-card class="card chat-comp">
  <mat-card-header>
    <mat-card-title>chat</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <div #chatBox class="chat-box">
      <p *ngFor="let message of chatMessages" #messages class="chat-message">
        <button mat-button [matMenuTriggerFor]="characterMenu" class="chat-character">
          <span *ngIf="!findCharacter(message.body.from)">{{ message.body.from }}</span>
          <span *ngIf="findCharacter(message.body.from)">{{ findCharacter(message.body.from)?.name }}</span>
        </button>
        <mat-menu #characterMenu>
          <button mat-menu-item disabled>profile</button>
          <button
            mat-menu-item
            (click)="setMode({ action: 'direct message', to: findCharacter(message.body.from)?.characterId })"
          >
            <span class="chat-message-text-direct">direct message</span>
          </button>
          <button mat-menu-item disabled>invite to group</button>
        </mat-menu>
        <span class="{{ getTextColorClass(message.type) }}">{{ message.body.text }}</span>
      </p>
    </div>
  </mat-card-content>
  <mat-card-actions class="chat-actions">
    <button mat-fab color="primary" [matMenuTriggerFor]="modeMenu">
      <mat-icon>list</mat-icon>
    </button>
    <mat-menu #modeMenu>
      <button mat-menu-item (click)="setMode({ action: 'broadcast' })">
        <span class="chat-message-text-broadcast">broadcast</span>
      </button>
      <button mat-menu-item (click)="setMode({ action: 'room' })" [disabled]="!joinedRoom">
        <span class="chat-message-text-room">room</span>
      </button>
    </mat-menu>
    <mat-form-field class="chat-input" appearance="fill">
      <mat-label>send message</mat-label>
      <input matInput #message maxlength="256" [(ngModel)]="messageText" (keyup.enter)="sendMessage()" />
      <mat-hint align="start" class="{{ getTextColorClass(mode.action) }}"
        >{{ mode.action }} {{ findCharacter(mode.to)?.name }}
      </mat-hint>
      <mat-hint align="end">{{ message.value.length }} / 256</mat-hint>
    </mat-form-field>
  </mat-card-actions>
</mat-card>
